<!--产品管理-->
<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">产品管理</p>

    <div class="formStyle">

      <p class="formTitle">产品详情填写</p>

      <Form :model="formItem" :label-width="100" style="padding:20px">
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">视频上传</Col>
            <Col span="15">
              <Upload multiple type="drag"
                      action="/zm/cos/upload"
                      :format="['mp4']"
                      :on-success="videoUploadSuccess">
                <div style="padding: 20px 20px">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>Click or drag videos here to upload</p>
                </div>
              </Upload>
            </Col>
          </Row>
        </formItem><!--视频上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">视频地址</Col>
            <Col span="15">
              <ul>
                <li v-for="(value,index) in videoPath" style="font-size: 1rem">
                  <span style="color: dodgerblue">{{value.name}}</span>&emsp;{{value.path}}
                </li>
              </ul>
            </Col>
          </Row>
        </formItem><!--视频地址-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">图片上传</Col>
            <Col span="15">
              <Upload multiple type="drag"
                      action="/zm/cos/upload"
                      :format="['jpg','jpeg','png']"
                      :on-success="imgUploadSuccess">
                <div style="padding: 20px 20px">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>Click or drag images here to upload</p>
                </div>
              </Upload>
            </Col>
          </Row>
        </formItem><!--图片上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">图片地址</Col>
            <Col span="15">
              <ul>
                <li v-for="(value,index) in imgPath" style="font-size: 1rem">
                  <span style="color: dodgerblue">{{value.name}}</span>&emsp;{{value.path}}
                </li>
              </ul>
            </Col>
          </Row>
        </formItem><!--图片地址-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品名称</Col>
            <Col span="15">
              <Input v-model="formItem.productTitle" placeholder="请输入产品名称..."></Input>
            </Col>
          </Row>
        </formItem><!--产品名称-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品id</Col>
            <Col span="15">
              <Input v-model="formItem.productId" placeholder="请输入产品id..."></Input>
            </Col>
          </Row>
        </formItem><!--产品id-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品appid</Col>
            <Col span="15">
              <Input v-model="formItem.appid" placeholder="软件有，硬件无.."></Input>
            </Col>
          </Row>
        </formItem><!--产品appid-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品简介</Col>
            <Col span="15">
              <Input v-model="formItem.productShortDescribe" placeholder="请输入产品简介..."></Input>
            </Col>
          </Row>
        </formItem><!--产品简介-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">详情</Col>
            <Col span="15">
              <Input v-model="formItem.productDescribe" type="textarea"
                     :autosize="{minRows: 4,maxRows: 8}"
                     placeholder="请输入产品详情..."></Input>
            </Col>
          </Row>
        </formItem><!--副标题-->
        <formItem style="text-align: right">
          <Button type="success" style="margin-right: 20%" @click.native="submitTotal">提交</Button>
        </formItem>
      </Form>
    </div>

  </div>
</template>

<script>
  export default {
    name: "productManager",
    data(){
      return{
        formItem:{
          playerSrc:"", //视频地址
          posterSrc:"", //图片地址
          productTitle:"", //产品标题
          productId:"", //产品id
          appid:"", //软件有，硬件无
          productShortDescribe:"", //产品简介
          productDescribe:""//产品描述
        },
        videoPath:[], //视频地址
        imgPath:[]//图片地址
      };
    },
    methods:{
      videoUploadSuccess(res, file){
        this.videoPath.push({name:file.name, path:res.content});
      }, //视频上传
      imgUploadSuccess(res, file){
        this.imgPath.push({name:file.name, path:res.content});
      }, //图片上传
      submitTotal(){
        this.formItem.playerSrc=this.videoPath[this.videoPath.length-1].path;
        this.formItem.posterSrc=this.imgPath[this.imgPath.length-1].path;
        console.log(this.formItem);
        this.$http.post('/zm/WMWebsite/addProductInfo', this.formItem).then(res => {
          this.$Message.success("上产成功！");
          this.formItem={
            playerSrc:"", //视频地址
            posterSrc:"", //图片地址
            productTitle:"", //产品标题
            productId:"", //产品id
            appid:"", //软件有，硬件无
            productShortDescribe:"", //产品简介
            productDescribe:""//产品描述
          };
          this.videoPath=[];
          this.imgPath=[];
        }, err => {
          this.$Message.error("上传失败！"+err.message);
        });
      }
    }
  };
</script>

<style scoped>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }  /*全局配置*/
  .formStyle{
    background-color: #fff;
    margin:2% auto;
    width: 96%;
    border-radius: 5px;
  }  /*表单外观设置*/
  .formTitle{
    font-size: 20px;
    font-family: "黑体";
    padding:15px;
    text-align: center;
  }  /*表单标题*/
  .formItemTitle{
    font-size: 18px;
  }  /*表单项目标题*/
</style>



// WEBPACK FOOTER //
// productManager.vue?fe1cf1e8